import React, { useEffect } from 'react';

const LoginSuccessPage = () => {
  useEffect(() => {
    window.opener?.postMessage('loginSuccess', window.location.origin);
    setTimeout(() => window.close(), 200);
  }, []);

  return <p>Login successful, please wait...</p>;
};

export default LoginSuccessPage;
